import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import {
	NgxValidateCoreModule,
	VALIDATION_ERROR_TEMPLATE,
	VALIDATION_INVALID_CLASSES,
	VALIDATION_TARGET_SELECTOR,
} from '@ngx-validate/core';
import { InlineSVGModule } from 'ng-inline-svg';

import { NgxsModule } from '@ngxs/store';

import { AccountLayoutComponent } from './components/account-layout/account-layout.component';
import { ApplicationLayoutComponent } from './components/application-layout/application-layout.component';
import { EmptyLayoutComponent } from './components/empty-layout/empty-layout.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LogoComponent } from './components/logo/logo.component';
import { HttpErrorComponent } from './components/http-error/http-error.component';
import { CurrentUserImageComponent } from './components/current-user-image/current-user-image.component';
import { NavItemsComponent } from './components/nav-items/nav-items.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { NavbarMobileComponent } from './components/navbar-mobile/navbar-mobile.component';
import { PageAlertContainerComponent } from './components/page-alert-container/page-alert-container.component';
import { RoutesComponent } from './components/routes/routes.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ValidationErrorComponent } from './components/validation-error/validation-error.component';
import { ScriptsInitComponent } from './components/init/scipts-init/scripts-init.component';

import { METRONIC_THEME_NAV_ITEM_PROVIDERS, METRONIC_THEME_SCRIPTS_PROVIDERS, METRONIC_THEME_SETTING_TAB_PROVIDERS, METRONIC_THEME_STYLES_PROVIDERS } from './providers';

import { LayoutState } from './states/layout.state';
import { CurrentUserComponent } from './components/nav-items/current-user.component';
import { LanguagesComponent } from './components/nav-items/languages.component';
import { SettingManagementComponent } from './components/settings/setting-management/setting-management.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FullScreenComponent } from './components/nav-items/full-screen.component';
import { HeaderMobileComponent } from './components/header-mobile/header-mobile.component';
import { MtStyDirective } from './directives/mt-sty.directive';

import { CoreModule as MetronicCoreModule } from './_metronic/core/core.module';
import { MetronicUiModule } from '@hedou/abp.metronic-ui';

export const LAYOUTS = [ApplicationLayoutComponent, AccountLayoutComponent, EmptyLayoutComponent];

@NgModule({
	declarations: [
		...LAYOUTS,
		HeaderComponent,
		FooterComponent,
		LogoComponent,
		HttpErrorComponent,
		CurrentUserImageComponent,
		NavItemsComponent,
		NavbarComponent,
		NavbarMobileComponent,
		PageAlertContainerComponent,
		RoutesComponent,
		SettingsComponent,
		SidebarComponent,
		ValidationErrorComponent,
		ScriptsInitComponent,
		LanguagesComponent,
		CurrentUserComponent,
		FullScreenComponent,
		SettingManagementComponent,
		BreadcrumbComponent,
		HeaderMobileComponent,
		MtStyDirective
	],
	exports: [
		...LAYOUTS,
		HeaderComponent,
		FooterComponent,
		LogoComponent,
		HttpErrorComponent,
		CurrentUserImageComponent,
		NavItemsComponent,
		NavbarComponent,
		NavbarMobileComponent,
		PageAlertContainerComponent,
		RoutesComponent,
		SettingsComponent,
		SidebarComponent,
		ValidationErrorComponent,
		ScriptsInitComponent,
		FullScreenComponent,
		LanguagesComponent,
		CurrentUserComponent,
		HeaderMobileComponent,
		MtStyDirective
	],
	imports: [
		MetronicCoreModule,
		CommonModule,
		CoreModule,
		InlineSVGModule,
		ThemeSharedModule,
		NgxValidateCoreModule,
		NgxsModule.forFeature([LayoutState]),
		NgbDropdownModule,
		MetronicUiModule,
	],
})
export class BaseMetronicThemeModule {

}

@NgModule({
	exports: [BaseMetronicThemeModule],
	imports: [BaseMetronicThemeModule],
})
export class MetronicThemeModule {

	static forRoot(): ModuleWithProviders<MetronicThemeModule> {
		return {
			ngModule: MetronicThemeModule,
			providers: [
				METRONIC_THEME_SCRIPTS_PROVIDERS,
				METRONIC_THEME_NAV_ITEM_PROVIDERS,
				METRONIC_THEME_SETTING_TAB_PROVIDERS,
				METRONIC_THEME_STYLES_PROVIDERS,
				{
					provide: VALIDATION_ERROR_TEMPLATE,
					useValue: ValidationErrorComponent,
				},
				{
					provide: VALIDATION_INVALID_CLASSES,
					useValue: 'input-validation-error',
				},
				{
					provide: VALIDATION_TARGET_SELECTOR,
					useValue: '.form-control',
				},
			],
		};
	}
}
